// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1ATjz","header":"ReportDetails_header__1skPv","title":"ReportDetails_title__2W8ya","left":"ReportDetails_left__3wY-0"};